import { modules } from "byzantine";
import { useBreakpoints } from "@narmi/design_system";

import CustomizationDialog from "./components/CustomizationDialog";
import { DashboardCustomizationProvider } from "./DashboardCustomizationContext";
import DashboardButton from "./components/DashboardButton";
import type { DashboardCustomizationProps } from "./types";
import DashboardCustomizationDrawer from "./DashboardCustomizationDrawer";

const { useIsDashboardCustomizationEnabled } = modules.userDisplayPreferences;
const { useDashboardLayoutRedesignEnabled } = modules.dashboard;

const DashboardCustomization = ({
  externalAccounts,
  servicesApps
}: DashboardCustomizationProps) => {
  const { l } = useBreakpoints();
  const { isDashboardCustomizationEnabled } =
    useIsDashboardCustomizationEnabled();

  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();

  // hide if flag off or not on desktop
  if (!isDashboardCustomizationEnabled || !l) {
    return null;
  }

  return (
    <DashboardCustomizationProvider
      externalAccounts={externalAccounts}
      servicesApps={servicesApps}
    >
      <DashboardButton />
      {isDashboardLayoutRedesignEnabled ? (
        <DashboardCustomizationDrawer />
      ) : (
        <CustomizationDialog />
      )}
    </DashboardCustomizationProvider>
  );
};

export default DashboardCustomization;
